import { useRef } from 'react';
import { DateTime as DT } from 'luxon';
import type { ProductType } from '@econtractor/types';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import CopyTextWrapper from 'components/others/CopyTextWrapper';
import PriceAndPriceSale from 'components/others/PriceAndPriceSale';
import ProductTitle from './ProductRowItems/ProductTitle';
import ProductTableRowActions from './ProductTableRowActions';
import { useProduct } from './context/ProductProvider';

interface ProductTableRowProps {
    product: ProductType;
    fetchProducts: (force?: boolean) => Promise<unknown>;
}

const ProductTableRow = ({ product, fetchProducts }: ProductTableRowProps) => {
    const { auth } = useAuth();
    const dt = DT.fromMillis(product?.prodUpdated || 0).toFormat('dd.MM.yyyy');
    const { setShowEditProduct, productCheck, setProductCheck } = useProduct();
    const refCheck = useRef<HTMLInputElement>(null);

    return (
        <tr>
            <td className="check">
                <input
                    className="form-check-input"
                    disabled={!hasUserAccess(auth?.user, 'prodEdit')}
                    ref={refCheck}
                    id={`check-${product.ID}`}
                    checked={productCheck?.includes(product.ID)}
                    onChange={(e) => {
                        setProductCheck((prev) => {
                            if (e.target.checked) {
                                return [...prev, product.ID];
                            }
                            return prev.filter((pId) => pId !== product.ID);
                        });
                    }}
                    type="checkbox"
                />
            </td>
            <td className="name">
                <ProductTitle
                    product={product}
                    fetchProducts={fetchProducts}
                    onClick={() => {
                        setShowEditProduct(product.ID);
                    }}
                />
            </td>
            <td className="id">
                <code>{product.ID}</code>
            </td>
            <td className="article text-truncate">
                <CopyTextWrapper value={product.prodArticle || ''}>
                    <span title={product.prodArticle}>{product.prodArticle}</span>
                </CopyTextWrapper>
            </td>
            <td className="price text-truncate">
                <PriceAndPriceSale
                    price={product?.prodDefPrice}
                    priceSale={product?.prodDefPriceSale}
                />
            </td>
            <td className="updated">{dt}</td>
            {hasUserAccess(auth?.user, 'prodEdit') && (
                <td className="action">
                    <ProductTableRowActions product={product} fetchProducts={fetchProducts} />
                </td>
            )}
        </tr>
    );
};

export default ProductTableRow;
